import { useRouterState } from '@tanstack/react-router';

export function useAppContext() {
	return useRouterState({
		select: (state) => {
			return state.matches.find((match) => match.context)?.context;
		},
	});
}
